import React from "react";
import { Modal } from "@/components";
import styles from "./SuccessSaveModal.module.scss";
import SuccessSaveDataIcon from "@/assets/img/success-change-data.png";

interface SuccessSaveModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SuccessSaveModal: React.FC<SuccessSaveModalProps> = ({
  isOpen,
  setIsOpen,
}) => {

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      title="Данные успешно обновлены!"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeFunc={handleClose}
      mobileContentSize="fixed"
    >
      <img className={styles.image} src={SuccessSaveDataIcon} alt="successSaveData" />
    </Modal>
  );
};
